<div class="grid">
    <div class="col-12">
      <p-panel [showHeader]="false">
        <canvas id="floor-main-editor"></canvas>
      </p-panel>
    </div>
  </div>
  